<div class="animate__animated animate__fadeInRight container-fluid">
  <mat-card class="mat-elevation-z5 mat_card_general_content border border-primary card_group_trabajadores m-2">
    <mat-tab-group>
      <mat-tab>
        <app-lista-ventas></app-lista-ventas>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</div>